import { PageContainer } from '~/@mid_ui/page-container/PageContainer'
import { WithdrawFunds } from './WithdrawFunds'

function WithdrawFundsPage() {
  return (
    <PageContainer className="flex flex-col items-center justify-center">
      <WithdrawFunds />
    </PageContainer>
  )
}

export default WithdrawFundsPage
